import { HelpParseKeyValueStringIdClaro } from "helpers/HelpParseKeyValueString";
import { decryptV8_CBC } from "helpers/encryptAES";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const IdClaroAvatar = () => {
  const estiloCentrado = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh", // O ajusta la altura según tus necesidades
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [urls, setUrls] = useState({ urlOK: "", urlReturn: "" });

  useEffect(() => {
    let token = searchParams.get("token");

    if (token) {
      try {
        token = decodeURIComponent(token).replace(/ /g, "+"); // Decodificar token
        const decryptedMessage = decryptV8_CBC(token); // Desencriptar
        const { urlOK, urlReturn } = HelpParseKeyValueStringIdClaro(decryptedMessage); // Parsear
        setUrls({ urlOK, urlReturn });
      } catch (error) {
        console.error("Error during decryption:", error.message);
      }
    }
  }, []);

  const handleButtonClick = (url) => {
    if (url) {
      window.location.href = url;
    }
  };
  return (
    <div className="container" style={estiloCentrado}>
      <div
        style={{
          textAlign: "center",
          border: "2px solid black",
          padding: "5rem",
          backgroundColor: "rgba(245,245,245,255)",
          maxWidth: "70%"
        }}
      >
        <h2>CLARO ID AVATAR</h2>
        <p>
          Este es un dummy para redireccionar a la<br></br>tienda V9, sólo es
          dar click en el botón.
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "10px",
            marginRight: "5px",
            marginLeft: "5px",
          }}
        >
          <button
            onClick={() => handleButtonClick(urls.urlOK)}
            style={{
              backgroundColor: "green",
              border: "none",
              borderRadius: "5px",
              padding: "10px",
              color: "white",
            }}
          >
            RETORNAR URL OK
          </button>
          <button
            onClick={() => handleButtonClick(urls.urlReturn)}
            style={{
              backgroundColor: "red",
              border: "none",
              borderRadius: "5px",
              padding: "10px",
              color: "white",
            }}
          >
            RETORNAR URL ERROR
          </button>
        </div>
        <div style={{
          maxWidth: "100%",
          overflowWrap: "break-word",
          margin: "5px 0"
        }}
        >
          <p>URL OK: {urls.urlOK}</p>
          <p>URL Error: {urls.urlReturn}</p>
        </div>
      </div>
    </div>
  );
};
export default IdClaroAvatar;